import React from 'react';
import { FiUsers } from 'react-icons/fi';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import { AiOutlineMedicineBox, AiOutlineDollar } from 'react-icons/ai';
import './StatsCards.css';

const StatsCards = () => {
  const stats = [
    { 
      title: 'Total Hospitals', 
      value: '24', 
      change: '+12%', 
      icon: <HiOutlineOfficeBuilding className="stats-icon" />,
      description: 'Active medical centers'
    },
    { 
      title: 'Active Doctors', 
      value: '156', 
      change: '+5%', 
      icon: <FiUsers className="stats-icon" />,
      description: 'Licensed practitioners'
    },
    { 
      title: 'Total Patients', 
      value: '2.4k', 
      change: '+18%', 
      icon: <AiOutlineMedicineBox className="stats-icon" />,
      description: 'Registered patients'
    },
    { 
      title: 'Revenue', 
      value: '$45.2k', 
      change: '+8%', 
      icon: <AiOutlineDollar className="stats-icon" />,
      description: 'Monthly earnings'
    }
  ];

  return (
    <div className="admin-stats-grid">
      {stats.map((stat, index) => (
        <div key={index} className="admin-stat-card">
          <div className="admin-stat-icon">{stat.icon}</div>
          <div className="admin-stat-details">
            <h3>{stat.title}</h3>
            <div className="admin-stat-numbers">
              <span className="admin-stat-value">{stat.value}</span>
              <span className={`admin-stat-change ${stat.change.startsWith('+') ? 'positive' : 'negative'}`}>
                {stat.change}
              </span>
            </div>
            <p className="admin-stat-description">{stat.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
